import { render, staticRenderFns } from "./study-site-association.vue?vue&type=template&id=17a967c0&scoped=true&"
import script from "./study-site-association.vue?vue&type=script&lang=js&"
export * from "./study-site-association.vue?vue&type=script&lang=js&"
import style0 from "./study-site-association.vue?vue&type=style&index=0&id=17a967c0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a967c0",
  null
  
)

component.options.__file = "study-site-association.vue"
export default component.exports